/*
 * @Author: wp
 * @Date: 2023-01-03 16:34:55
 * @Descripttion:
 */
// 在此注册全局常量 相当于在vue中的 main.js 中注册
import Vue from 'vue'
import Enum from '@/enum'
const timeQs = require('silly-datetime')
// 全局常量

export default ({ $axios, app, store }, inject) => {
    inject('formattedDateTime', function (data = '') {
        return timeQs.format(new Date(), 'YYYY-MM-DDTHH:mm:ss')
    })
}

Vue.prototype.$enum = Enum
